import { useEffect, useState } from "react";
import { useLang } from "../../lib/i18n";
import { api } from "../../lib/api";
import { fmtDateTime } from "../../lib/helpers";
import { Section } from "../common";

export function VoiceConversations({ customerId }) {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/voice-ai/conversations?customer_id=${customerId}`).then((r) => setItems(r.data)).catch(() => {}); }, [customerId]);
  if (!items.length) return null;
  return (
    <Section title={t("Voice AI calls", "Llamadas con IA de voz")} count={items.length} testid="customer-voice-conversations">
      {items.map((x) => (
        <details key={x.id} className="px-4 py-2 border-b text-sm" data-testid={`voice-conv-${x.id}`}>
          <summary className="cursor-pointer font-semibold">{fmtDateTime(x.started_at, lang)} · {x.direction === "inbound" ? t("Incoming", "Entrante") : t("Outgoing", "Saliente")} · {x.language?.toUpperCase()}</summary>
          {x.summary && <p className="mt-1 text-slate-700">{x.summary}</p>}
          {x.transcript.map((m, i) => <p key={i} className="text-xs text-slate-500"><b>{m.role === "ai" ? "AI" : t("Customer", "Cliente")}:</b> {m.text}</p>)}
        </details>
      ))}
    </Section>
  );
}
